export default __webpack_public_path__ + "static/media/reward2_detail_step3.147acfbc.png";